import { render, staticRenderFns } from "./FeatureAccessDenied.vue?vue&type=template&id=a7174824&scoped=true&"
import script from "./FeatureAccessDenied.vue?vue&type=script&lang=js&"
export * from "./FeatureAccessDenied.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7174824",
  null
  
)

export default component.exports